/* eslint-disable react/jsx-props-no-spreading */
import React, { memo } from 'react';

import { CustomInput } from './styles';

const ReactInput = props => <CustomInput {...props} />;

export default memo(ReactInput);
